import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { StatedataService } from "../services/statedata.service";

@Injectable({
    providedIn: "root"
})
export class VolatileStateGuard  {
    private readonly statedataService = inject(StatedataService);

    canActivateChild(childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        const { volatileState } = childRoute.data;
        this.statedataService.handleNavigation(volatileState ?? "");
        this.statedataService.updateParams(childRoute);
        return true;
    }
}
